import { SiteProps } from "../interfaces"
import IS3Document from "../interfaces/IS3Document"
import { validDurations, validCampingStyles, validKinds } from "../types"
import { destroy, get, patch, post, transformRequestData } from "./utils/requests"

export type IUpdateProps = {
  camping_style?: validCampingStyles
  name?: string
  is_bookable?: boolean
  kind?: validKinds
  last_meter_reading?: number
  camper_capacity?: number
  max_rig_length?: number
  minimum_capacity?: number
  electric?: boolean
  water?: boolean
  has_linens?: boolean
  notes?: string
  checkin_policy_additions?: string
  vendor_calendars_attributes?: {
    id?: string
    kind: string
    calendar_url: string
    _destroy?: boolean
  }[]
  prices_attributes?: {
    duration: validDurations
    amount_in_cents: number
  }[]
}

const update = (id: string, data: IUpdateProps): Promise<{ site: SiteProps }> => patch(`/sites/${id}`, { site: data })

const fetchImages = async (id: string): Promise<{ images: Array<IS3Document> }> => get(`/api/sites/${id}/images`)

const uploadImage = async (id: string, file: File): Promise<{ image: IS3Document }> => {
  const formData = new FormData()
  formData.append("file", file)
  const response = await fetch(`/api/sites/${id}/images`, {
    method: "POST",
    body: formData,
  })

  if (!response.ok) {
    throw new Error("Failed to upload image")
  }

  const resp = await response.json()

  return resp
}

const removeImage = async (id: string, key: string): Promise<{ message: string }> =>
  destroy(`/api/sites/${id}/images`, { key })

const availabilities = async (
  campId: string,
  params: {
    startDate: string
    endDate: string
    ignoredReservationIds?: string[]
  },
): Promise<{ sites: Pick<SiteProps, "id" | "is_available" | "name" | "sort" | "camping_style_id">[] }> =>
  get(`/api/camps/${campId}/availabilities`, transformRequestData(params))

const duplicate = async (id: string): Promise<{ site: SiteProps }> => post(`/api/sites/${id}/duplicate`)

const remove = async (id: string): Promise<{ message: string }> => destroy(`/api/sites/${id}`)

const batchUpdateSort = async (siteUpdates: Record<string, number>): Promise<{ message: string }> => 
  patch(`/api/sites/batch_update_sort`, { sites: siteUpdates })

const Sites = {
  availabilities,
  batchUpdateSort,
  duplicate,
  fetchImages,
  remove,
  removeImage,
  update,
  uploadImage,
}

export default Sites
